module.exports = __webpack_public_path__ + "img/duckyAPP.f94a7727.png";